import { withStyles } from '@material-ui/core/styles';
import MuiButton from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { useState } from 'react';
import * as API from 'api';
import { useMutation } from 'react-query';
import MuiDeleteIcon from '@mui/icons-material/Delete';
import MuiTypography from '@material-ui/core/Typography';
import MuiBox from '@material-ui/core/Box';

const QueryLibrary = API.QueryLibrary();

const styles = theme => ({
  dialogFooter: {
    padding: theme.spacing(1.5),
  },
  actionButton: {
    borderRadius: 100,
    minWidth: 32,
    minHeight: 32,
    padding: 0,
  },
});

const DeleteQuery = ({ refetch, id, ...props }) => {
  const { classes } = props;
  const [open, setOpen] = useState(false);

  const deleteQuery = useMutation(({ id }) => QueryLibrary.deleteQueryLibraryPrompt({ id }), {
    onSuccess: () => {
      handleClose();
      refetch();
    },
    onError: error => {
      alert(error.data?.message || 'Unknown Error');
      deleteQuery.reset();
    },
  });

  function handleClick() {
    setOpen(true);
  }
  function handleClose() {
    setOpen(false);
  }
  function handleDelete() {
    deleteQuery.mutate({ id });
  }

  return (
    <MuiBox>
      <MuiButton variant="text" color="primary" className={classes.actionButton} onClick={handleClick}>
        <MuiDeleteIcon />
      </MuiButton>
      <MuiDialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <MuiDialogTitle id="form-dialog-title">Delete query</MuiDialogTitle>
        <MuiDialogContent>
          <MuiTypography variant="body1">Are you sure you want to delete this query?</MuiTypography>
        </MuiDialogContent>
        <MuiDialogActions className={classes.dialogFooter}>
          <MuiButton variant="contained" onClick={handleClose}>
            Cancel
          </MuiButton>
          <MuiButton variant="contained" color="primary" onClick={handleDelete} disabled={deleteQuery.isLoading}>
            {deleteQuery.isLoading ? 'Deleting...' : 'Delete query'}
          </MuiButton>
        </MuiDialogActions>
      </MuiDialog>
    </MuiBox>
  );
};

export default withStyles(styles)(DeleteQuery);
